import React, {PureComponent} from 'react';
import './MainBoxCollapsible.css';
import ChildBoxCollapsible from '../ChildBoxCollapsible/ChildBoxCollapsible';

class MainBoxCollapsible extends PureComponent {
  state = {
    subItems: [],
    isActive: false,
    active: ''
  };

  reset() {
    const subItems = [];
    const isActive = false;
    const active = '';
    this.setState({subItems: subItems, isActive, active});
  };

  componentWillUnmount() {
    this.reset();
  }

  componentWillReceiveProps(props) {
    const {subItems, isActive} = props;

    this.setState({subItems: subItems, isActive});
  }

  /*SUB-ITEMS*/
  handleActive = (index) => {
    const {active} = this.state;
    const newValue = index === active ? '' : index;

    this.setState({active: newValue});
  };

  titleContentRender = () => {
    const {color, image, title} = this.props;

    return (
      <div className='title-container'>
        <div className='title-box' style={{backgroundImage: `url(${image})`, backgroundSize: 'cover'}}>
          <span className='title-text' style={{backgroundColor: `${color}`}}>
            {`${title}`}
          </span>
        </div>
      </div>
    )
  };

  subContentRender = () => {
    const {subContent} = this.props;

    return (
      <div className='sub-content'>
        <div dangerouslySetInnerHTML={{__html: subContent}}/>
      </div>
    )
  };

  subItemsRender = () => {
    const {subItems, active, isActive} = this.state;

    return (isActive && subItems && subItems.length > 0) ?
      <div className='sub-items'>
        <div>
          {
            subItems.map((item, index) => {
              return <ChildBoxCollapsible
                key={index}
                index={index}
                isActive={index === active}
                title={item.title}
                subTitle={item.subTitle}
                content={item.content}
                handleActive={this.handleActive}
              />
            })
          }
        </div>
      </div>
      : null;
  };

  render() {
    const {isActive} = this.state;
    const {content, index, id, handleActive} = this.props;
    const imageActive = '/wp-content/uploads/2018/09/arrow.png';
    const imageDisable = '/wp-content/uploads/2018/09/close.png';
    /*const imageActive = '/assets/arrow.png';
    const imageDisable = '/assets/close.png';*/

    const indexInitial = content.indexOf('<p>');
    const indexEnd = content.indexOf('</p>');
    const previewText = content.slice(indexInitial, indexEnd).slice(0, 140).concat('...');
    let dynamicText = !isActive ? previewText : content;

    return (
      <div id='Main-box-collapsible' className={(isActive) ? 'active' : ''}>
        <div className='master-box'>
          {this.titleContentRender()}
          <div className='content-container'>
            <div className='content-content'><span><div dangerouslySetInnerHTML={{__html: dynamicText}}/></span></div>
            <div className='button-collapsible-content'>
              <a href={`#${(isActive) ? id : ''}`}><img alt='button' src={isActive ? imageDisable : imageActive}
                                                        onClick={() => handleActive(index)}/></a>
              <div style={{position: 'relative', color: 'red', top: -150}} id={id}/>
            </div>
          </div>
        </div>
        {this.subContentRender()}
        {this.subItemsRender()}
      </div>
    )
  }
}

export default MainBoxCollapsible;



// WEBPACK FOOTER //
// ./src/components/CollapseMaster/MainBoxCollapsible/MainBoxCollapsible.js